import { IconProps } from '@euler/app/components/icons/types';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { FC, memo } from 'react';
import Svg, { Path } from 'react-native-svg';

export const ReportsIcon: FC<IconProps> = memo(
  ({ size, width, height, ...props }) => {
    const { rpx } = useResponsiveContext();
    size = size ?? rpx(64);
    return (
      <Svg
        viewBox="0 0 1024 1024"
        width={width ?? size}
        height={height ?? size}
        {...props}
      >
        <Path
          d="M354.4576 896a25.6 25.6 0 0 0 25.6 25.6H896a25.6 25.6 0 0 0 25.6-25.6V359.936a25.6 25.6 0 0 0-8.832-19.3536l-158.464-137.3952a25.6 25.6 0 0 0-16.768-6.272H380.0576a25.6 25.6 0 0 0-25.6 25.6V896z"
          fill="#43E0A2"
        />
        <Path
          d="M102.4 793.6a25.6 25.6 0 0 0 25.6 25.6h563.2a25.6 25.6 0 0 0 25.6-25.6V317.7984a25.6 25.6 0 0 0-7.5008-18.0992l-189.7984-189.7984A25.6 25.6 0 0 0 501.4016 102.4H128a25.6 25.6 0 0 0-25.6 25.6v665.6z"
          fill="#478BFF"
        />
        <Path
          d="M204.8 307.2m51.2 0l204.8 0q51.2 0 51.2 51.2l0 0q0 51.2-51.2 51.2l-204.8 0q-51.2 0-51.2-51.2l0 0q0-51.2 51.2-51.2Z"
          fill="#FFFFFF"
        />
        <Path
          d="M204.8 512m51.2 0l307.2 0q51.2 0 51.2 51.2l0 0q0 51.2-51.2 51.2l-307.2 0q-51.2 0-51.2-51.2l0 0q0-51.2 51.2-51.2Z"
          fill="#FFFFFF"
        />
      </Svg>
    );
  },
);
